<div class="px-3 py-5">
    <div class="theme-container"> 
        <mat-sidenav-container class="checkout">
            
            <mat-sidenav-content ngClass.gt-sm="distance">
                <mat-card *ngIf="!sidenavOpen" fxLayout="row" fxLayoutAlign="space-between center" class="mb-3"> 
                    <h2 class="secondary-font">Order Summary</h2>
                    <button mat-icon-button (click)="sidenav.toggle()">
                        <mat-icon class="text-muted">more_vert</mat-icon>
                    </button>
                </mat-card>  

                <mat-accordion [formGroup]="checkoutForm" hideToggle>

                    <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" [disabled]="orderCompleted">    
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon *ngIf="checkoutForm.get('deliveryAddress')!.valid" color="primary">check_circle</mat-icon>
                                <mat-icon *ngIf="!checkoutForm.get('deliveryAddress')!.valid" class="text-muted">unpublished</mat-icon>
                                <span class="mx-2">Delivery Address</span>    
                            </mat-panel-title> 
                        </mat-expansion-panel-header> 
                        <form formGroupName="deliveryAddress" fxLayout="row wrap" class="flex-wrapper">
                            <div fxFlex="100" class="px-3 mb-4">
                                <h1 class="fw-500 text-center secondary-font">Delivery Address</h1>
                            </div> 
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>First Name</mat-label>
                                    <input matInput placeholder="First Name" formControlName="firstName" required>  
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.firstName')!.errors?.required">First Name is required</mat-error>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.firstName')!.hasError('maxNumberOfWordsExceeded')">Max number of words exceeded</mat-error> 
                                </mat-form-field> 
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Last Name</mat-label>
                                    <input matInput placeholder="Last Name" formControlName="lastName" required>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.lastName')!.errors?.required">Last Name is required</mat-error>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.lastName')!.hasError('maxNumberOfWordsExceeded')">Max number of words exceeded</mat-error> 
                                </mat-form-field> 
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Middle Name</mat-label>
                                    <input matInput placeholder="Middle Name" formControlName="middleName"> 
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.middleName')!.hasError('maxNumberOfWordsExceeded')">Max number of words exceeded</mat-error> 
                                </mat-form-field> 
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Company</mat-label>
                                    <input matInput placeholder="Company" formControlName="company"> 
                                </mat-form-field> 
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Email</mat-label>
                                    <input matInput placeholder="Enter your email" formControlName="email" required>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.email')!.errors?.required">Email is required</mat-error>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.email')!.hasError('invalidEmail')">Invalid email address</mat-error> 
                                </mat-form-field> 
                            </div> 
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Phone</mat-label>
                                    <input matInput placeholder="Enter your phone" formControlName="phone" required appPhoneMask>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.phone')!.errors?.required">Phone is required</mat-error> 
                                </mat-form-field> 
                            </div> 
                            <div fxFlex="100" fxFlex.gt-sm="25" class="px-3">  
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Country</mat-label>
                                    <mat-select placeholder="Select country" formControlName="country" required>
                                        <mat-option *ngFor="let country of countries" [value]="country.code">
                                            {{country.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.country')!.errors?.required">Country is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="25" class="px-3"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>City</mat-label>
                                    <input matInput placeholder="City" formControlName="city" required>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.city')!.errors?.required">City is required</mat-error> 
                                </mat-form-field> 
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="25" class="px-3"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Place</mat-label>
                                    <input matInput placeholder="Place" formControlName="place" required>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.place')!.errors?.required">Place is required</mat-error> 
                                </mat-form-field> 
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="25" class="px-3"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Postal Code</mat-label>
                                    <input matInput placeholder="Postal Code" formControlName="postalCode" required>
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.postalCode')!.errors?.required">Postal Code is required</mat-error> 
                                </mat-form-field> 
                            </div>
                            <div fxFlex="100" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Address</mat-label> 
                                    <textarea matInput placeholder="Address (street, apartment, suite, unit etc.)" formControlName="address" required rows="5"></textarea> 
                                    <mat-error *ngIf="checkoutForm.get('deliveryAddress.address')!.errors?.required">Address is required</mat-error>
                                </mat-form-field>
                            </div>  
                            <div fxFlex="100" class="pb-2 px-3" fxLayoutAlign="end center">
                                <button mat-raised-button color="primary" fxLayout="row" fxLayoutAlign="center center" (click)="onSubmitForm('deliveryAddress')" type="submit">
                                  <span class="mx-1 uppercase">Next</span>                    
                                  <mat-icon>navigate_next</mat-icon>
                                </button> 
                            </div>
                        </form>   
                    </mat-expansion-panel>
                  
                    <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" [disabled]="!checkoutForm.get('deliveryAddress')!.valid">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon *ngIf="checkoutForm.get('deliveryMethod')!.valid" color="primary">check_circle</mat-icon>
                                <mat-icon *ngIf="!checkoutForm.get('deliveryMethod')!.valid" class="text-muted">unpublished</mat-icon>
                                <span class="mx-2">Delivery Method</span>
                            </mat-panel-title> 
                        </mat-expansion-panel-header> 
                        <form formGroupName="deliveryMethod" fxLayout="row wrap" class="flex-wrapper">
                            <div fxFlex="100" class="px-3 mb-4">
                                <h1 class="fw-500 text-center secondary-font">Delivery Method</h1>
                            </div>  
                            <div fxFlex="100" class="px-3">
                                <mat-radio-group formControlName="method" fxLayout="column" fxLayoutAlign="center" required name="methods">
                                    <mat-radio-button *ngFor="let method of deliveryMethods" color="primary" [value]="method" class="mt-1"><b>{{method.name}}</b> {{method.desc}}</mat-radio-button>
                                </mat-radio-group> 
                                <mat-error *ngIf="deliveryMethodSubmitted && checkoutForm.get('deliveryMethod.method')!.errors?.required" class="mt-1">
                                    <small>Delivery method is required</small>
                                </mat-error> 
                            </div> 
                            <div fxFlex="100" class="mt-3 p-2" fxLayoutAlign="space-between center">
                                <button mat-raised-button color="primary" fxLayout="row" fxLayoutAlign="center center" (click)="prevStep()" type="button">
                                    <mat-icon>navigate_before</mat-icon>
                                    <span class="mx-1 uppercase">Back</span>  
                                </button>
                                <button mat-raised-button color="primary" fxLayout="row" fxLayoutAlign="center center" (click)="onSubmitForm('deliveryMethod')" type="submit">
                                    <span class="mx-1 uppercase">Next</span>                    
                                    <mat-icon>navigate_next</mat-icon>
                                </button> 
                            </div>  
                        </form> 
                    </mat-expansion-panel>
                  
                    <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" [disabled]="!checkoutForm.get('deliveryAddress')!.valid || !checkoutForm.get('deliveryMethod')!.valid">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon *ngIf="checkoutForm.get('paymentMethod')!.valid" color="primary">check_circle</mat-icon>
                                <mat-icon *ngIf="!checkoutForm.get('paymentMethod')!.valid" class="text-muted">unpublished</mat-icon>
                                <span class="mx-2">Payment Method</span>
                            </mat-panel-title> 
                        </mat-expansion-panel-header>
                        <form formGroupName="paymentMethod" fxLayout="row wrap" class="flex-wrapper">
                            <div fxFlex="100" class="px-3 mb-4">
                                <h1 class="fw-500 text-center secondary-font">Payment Method</h1>
                            </div>
                            
                            <div fxFlex="100" fxLayout="column" fxLayoutAlign="start start" class="p-3">
                                <span class="text-muted">Credit Card</span>
                                <img src="assets/images/others/payments.png" alt="">
                            </div>        
                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Card holder name</mat-label>
                                    <input matInput placeholder="Card holder name" formControlName="cardHolderName" required>
                                    <mat-error *ngIf="checkoutForm.get('paymentMethod.cardHolderName')!.errors?.required">Card holder name name is required</mat-error> 
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Card number</mat-label>
                                    <input matInput placeholder="Card number" formControlName="cardNumber" required>
                                    <mat-error *ngIf="checkoutForm.get('paymentMethod.cardNumber')!.errors?.required">Card number is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Expired month</mat-label>
                                    <mat-select placeholder="Expired month" formControlName="expiredMonth" required>
                                      <mat-option *ngFor="let month of months" [value]="month.value">
                                          {{month.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="checkoutForm.get('paymentMethod.expiredMonth')!.errors?.required">Expired month is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Expired year</mat-label>
                                    <mat-select placeholder="Expired year" formControlName="expiredYear" required>
                                      <mat-option *ngFor="let year of years" [value]="year">
                                          {{year}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="checkoutForm.get('paymentMethod.expiredYear')!.errors?.required">Expired year is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>CVV</mat-label>
                                    <input matInput placeholder="CVV" formControlName="cvv" required maxlength="3">
                                    <mat-error *ngIf="checkoutForm.get('paymentMethod.cvv')!.errors?.required">CVV is required</mat-error>
                                    <mat-error *ngIf="checkoutForm.get('paymentMethod.cvv')!.hasError('minlength')">CVV isn't long enough, minimum of 3 characters</mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" class="mt-3 p-2" fxLayoutAlign="space-between center">
                                <button mat-raised-button color="primary" fxLayout="row" fxLayoutAlign="center center" (click)="prevStep()" type="button">
                                    <mat-icon>navigate_before</mat-icon>
                                    <span class="mx-1 uppercase">Back</span>  
                                </button>
                                <button mat-raised-button color="primary" fxLayout="row" fxLayoutAlign="center center" (click)="onSubmitForm('paymentMethod')" type="submit">
                                    <span class="mx-1 uppercase">Next</span>                    
                                    <mat-icon>navigate_next</mat-icon>
                                </button> 
                            </div>
                        </form>  
                    </mat-expansion-panel> 
                  
                    <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)" [disabled]="!checkoutForm.get('deliveryAddress')!.valid || !checkoutForm.get('deliveryMethod')!.valid || !checkoutForm.get('paymentMethod')!.valid">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon *ngIf="checkoutForm.get('paymentMethod')!.valid" color="primary">check_circle</mat-icon>
                                <mat-icon *ngIf="!checkoutForm.get('paymentMethod')!.valid" class="text-muted">unpublished</mat-icon>
                                <span class="mx-2">Order Review</span>
                            </mat-panel-title> 
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" class="flex-wrapper" *ngIf="checkoutForm.get('deliveryAddress')!.valid"> 
                            <div fxFlex="100" class="px-3 mb-2">
                                <h2 class="secondary-font">Delivery Address</h2>
                            </div>
                            <div fxFlex="100" class="px-3 mb-2">
                                <div class="divider"></div>
                            </div>  
                            <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
                                <p class="text-muted mb-1">Name:</p>
                                <p>{{checkoutForm.get('deliveryAddress.firstName')!.value}} {{checkoutForm.get('deliveryAddress.lastName')!.value}}</p>
                            </div>
                            <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
                                <p class="text-muted mb-1">Email:</p>
                                <p>{{checkoutForm.get('deliveryAddress.email')!.value}}</p>
                            </div>
                            <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
                                <p class="text-muted mb-1">Phone:</p>
                                <p>{{checkoutForm.get('deliveryAddress.phone')!.value}}</p>
                            </div>
                            <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
                                <p class="text-muted mb-1">Country:</p>
                                <p>{{checkoutForm.get('deliveryAddress.country')!.value}}</p>
                            </div>
                            <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
                                <p class="text-muted mb-1">City:</p>
                                <p>{{checkoutForm.get('deliveryAddress.city')!.value}}</p>
                            </div>
                            <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
                                <p class="text-muted mb-1">Place:</p>
                                <p>{{checkoutForm.get('deliveryAddress.place')!.value}}</p>
                            </div>
                            <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
                                <p class="text-muted mb-1">Zip/PostalCode:</p>
                                <p>{{checkoutForm.get('deliveryAddress.postalCode')!.value}}</p>
                            </div>
                            <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
                                <p class="text-muted mb-1">Address:</p>
                                <p>{{checkoutForm.get('deliveryAddress.address')!.value}}</p>
                            </div> 


                            <div fxFlex="100" class="px-3 mb-2 mt-3">
                                <h2 class="secondary-font">Delivery Method</h2>
                            </div>
                            <div fxFlex="100" class="px-3">
                                <div class="divider"></div>
                            </div> 
                            <div fxFlex="100" class="px-3 mb-4" *ngIf="checkoutForm.get('deliveryMethod')!.valid">
                                <p class="py-1">{{checkoutForm.get('deliveryMethod.method')!.value['name']}} <span class="text-muted">{{checkoutForm.get('deliveryMethod.method')!.value['desc']}}</span></p>
                            </div> 

                            <div fxFlex="100" class="px-3 mb-2">
                                <h2 class="secondary-font">Payment Method</h2>
                            </div>
                            <div fxFlex="100" class="px-3">
                                <div class="divider"></div>
                            </div> 
                            <div fxFlex="100" class="px-3 mb-4">
                                <p class="py-1"><span class="text-muted">Card number:</span><span class="mx-1">XXX-XXX-XXX-7224</span></p>
                            </div> 

                            <div fxFlex="100" class="px-3 mb-2">
                                <h2 class="secondary-font">Shopping Cart</h2>
                            </div>
                            <div fxFlex="100" class="px-3 mb-5">
                                <div class="divider"></div>
                                <div class="mat-table theme-table review-order-table">
                                    <div class="mat-header-row">
                                        <div class="mat-header-cell image">Image</div>
                                        <div class="mat-header-cell">Name</div>
                                        <div class="mat-header-cell price">Unit Price</div>      
                                        <div class="mat-header-cell quantity">Quantity</div>
                                        <div class="mat-header-cell total">Total</div> 
                                    </div> 
                                    <div *ngFor="let item of appService.Data.cartList" class="mat-row">
                                        <div class="mat-cell image"><img [src]="item.image.small" alt="item"></div>
                                        <div class="mat-cell"><a [routerLink]="['/menu', item.id]" class="menu-item-name">{{item.name}}</a></div>
                                        <div class="mat-cell price">  
                                            <span *ngIf="!item.discount" class="primary-color py-3"> 
                                                {{item.price | currency : 'USD' : 'symbol' : '1.2-2'}}  
                                            </span> 
                                            <span *ngIf="item.discount" class="primary-color py-3">  
                                                {{ (item.price - (item.price * (item.discount / 100))) | currency : 'USD' : 'symbol' : '1.2-2'}}
                                            </span>  
                                        </div>      
                                        <div class="mat-cell quantity">{{item.cartCount}}</div>
                                        <div class="mat-cell total">
                                            <span *ngIf="!item.discount" class="primary-color py-3"> 
                                                {{item.price*item.cartCount | currency : 'USD' : 'symbol' : '1.2-2'}}  
                                            </span> 
                                            <span *ngIf="item.discount" class="primary-color py-3">   
                                                {{ (item.price - (item.price * (item.discount / 100)))*item.cartCount | currency : 'USD' : 'symbol' : '1.2-2'}}
                                            </span>  
                                        </div> 
                                    </div> 
                                    <div class="mat-row">
                                        <div class="mat-cell image"></div>
                                        <div class="mat-cell"></div>
                                        <div class="mat-cell price"></div>
                                        <div class="mat-cell quantity text-right">
                                        <div fxLayout="column" fxLayoutAlign="center end" class="grand-total px-2">
                                            <span>SubTotal:</span>
                                            <span class="text-muted">Discount:</span>
                                            <span>Grand total:</span>
                                        </div>        
                                        </div>
                                        <div class="mat-cell total">
                                            <div fxLayout="column" fxLayoutAlign="center start" class="grand-total">
                                                <span>{{ appService.Data.totalPrice | currency : 'USD' : 'symbol' : '1.2-2'}}</span>
                                                <span class="text-muted">15%</span>
                                                <span class="primary-color">{{ (appService.Data.totalPrice - (appService.Data.totalPrice*0.15)) | currency : 'USD' : 'symbol' : '1.2-2'}}</span>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div> 

                            <div fxFlex="100" class="mt-3 p-2" fxLayoutAlign="space-between center">
                                <button mat-raised-button color="primary" fxLayout="row" fxLayoutAlign="center center" (click)="prevStep()" type="button">
                                    <mat-icon>navigate_before</mat-icon>
                                    <span class="mx-1 uppercase">Back</span>  
                                </button>
                                <button mat-raised-button color="primary" fxLayout="row" fxLayoutAlign="center center" (click)="placeOrder()" type="button" [disabled]="!appService.Data.cartList.length">
                                    <span class="mx-1 uppercase">Place Order Now</span>
                                </button> 
                            </div> 
                            
                        </div>  
                    </mat-expansion-panel>  

                    <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)" [disabled]="!orderCompleted">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon *ngIf="orderCompleted" color="primary">check_circle</mat-icon>
                                <mat-icon *ngIf="!orderCompleted" class="text-muted">unpublished</mat-icon>
                                <span class="mx-2">Confirmation</span>
                            </mat-panel-title> 
                        </mat-expansion-panel-header> 

                        <div fxLayout="column" fxLayoutAlign="center center" class="px-3 pb-3 text-center">
                            <h1 class="secondary-font mb-3">Thank You!</h1>
                            <h2 class="my-3">Your order #1035248 has been processed</h2>
                            <p class="text-muted">We are getting started on your order right away and you will receive an order confirmation email shortly to <b>{{orderEmail}}</b>. If the email hasn't arrived within two minutes, please check your spam folder to see if the email was routed there. In the meantime explore the others items and get inspired by new products just head over to <a routerLink="/" class="primary-color">Restaurant</a>.</p>
                            <a [routerLink]="['/menu']" mat-raised-button color="primary">Return to Shop</a>   
                        </div> 
                       
                    </mat-expansion-panel> 
                  
                </mat-accordion>  

            </mat-sidenav-content>

            <mat-sidenav #sidenav position="end" [opened]="sidenavOpen" [mode]="sidenavOpen ? 'side' : 'over'">
                <mat-card [perfectScrollbar]="psConfig"> 
                    <button fxHide="false" fxHide.gt-sm mat-mini-fab color="warn" class="close" (click)="sidenav.toggle()">
                        <mat-icon>close</mat-icon>
                    </button> 
                    <div fxLayoutAlign="start center">
                        <mat-icon class="text-muted">receipt_long</mat-icon>
                        <h2 class="secondary-font mx-2">Order Summary</h2>
                    </div>  
                    <div class="divider my-3"></div>
                    <div *ngFor="let menuItem of appService.Data.cartList" fxLayout="row" fxLayoutAlign="space-between start" class="mb-3">
                        <div fxLayout="row" fxLayoutAlign="start start">
                            <img [src]="menuItem.image.small" width="60" alt="item"> 
                            <a [routerLink]="['/menu', menuItem.id]" class="menu-item-name px-2">{{menuItem.name}}</a>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="end end">
                            <span *ngIf="!menuItem.discount" class="fw-500"> 
                                {{menuItem.price | currency : 'USD' : 'symbol' : '1.2-2'}}  
                            </span> 
                            <span *ngIf="menuItem.discount" class="fw-500">  
                                {{ (menuItem.price - (menuItem.price * (menuItem.discount / 100))) | currency : 'USD' : 'symbol' : '1.2-2'}}
                            </span> 
                            <small class="text-muted ws-nowrap fw-500">Qty: {{menuItem.cartCount}}</small>
                        </div>  
                    </div>
                    <div *ngIf="appService.Data.cartList.length == 0" fxLayout="column" fxLayoutAlign="center center" class="text-center py-2"> 
                        <svg viewBox="0 0 24 24" class="mat-icon mat-icon-xlg primary-color">
                            <path d="M19 20C19 21.11 18.11 22 17 22C15.89 22 15 21.1 15 20C15 18.89 15.89 18 17 18C18.11 18 19 18.9 19 20M7 18C5.89 18 5 18.89 5 20C5 21.1 5.89 22 7 22C8.11 22 9 21.11 9 20S8.11 18 7 18M7.2 14.63L7.17 14.75C7.17 14.89 7.28 15 7.42 15H19V17H7C5.89 17 5 16.1 5 15C5 14.65 5.09 14.32 5.24 14.04L6.6 11.59L3 4H1V2H4.27L5.21 4H20C20.55 4 21 4.45 21 5C21 5.17 20.95 5.34 20.88 5.5L17.3 11.97C16.96 12.58 16.3 13 15.55 13H8.1L7.2 14.63M8.5 11H10V9H7.56L8.5 11M11 9V11H14V9H11M14 8V6H11V8H14M17.11 9H15V11H16L17.11 9M18.78 6H15V8H17.67L18.78 6M6.14 6L7.08 8H10V6H6.14Z" />
                        </svg> 
                        <h3 class="secondary-font mt-3">Your Cart Is Currently Empty!</h3>
                        <p class="text-muted">Before proceed to checkout you must add some items to your shopping cart.</p>  
                        <a [routerLink]="['/menu']" mat-raised-button color="primary" class="mt-2 mb-3">Return To Shop</a> 
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start" class="divider pt-2">
                        <div fxLayout="column" fxLayoutAlign="start start">
                            <span>SubTotal:</span>
                            <span class="text-muted">Discount:</span>
                            <h3>Grand total:</h3>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="end end"> 
                            <span>{{appService.Data.totalPrice | currency : 'USD' : 'symbol' : '1.2'}}</span> 
                            <span class="text-muted">15%</span>
                            <h3 class="primary-color">{{ (appService.Data.totalPrice - (appService.Data.totalPrice*0.15)) | currency : 'USD' : 'symbol' : '1.2-2'}}</h3> 
                        </div> 
                    </div> 
                    <button mat-raised-button color="primary" type="button" class="mt-2 w-100" [disabled]="!appService.Data.cartList.length" (click)="placeOrder()">Place Order Now</button>           
                </mat-card>  
            </mat-sidenav>
        </mat-sidenav-container> 
    </div>
</div>